import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { PlayPage } from '../play/play'; 
import { ReadstoryPage } from '../readstory/readstory'; 

import { Storage } from '@ionic/storage';
import { Slides } from 'ionic-angular';
import { ViewChild } from '@angular/core';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { SmartAudio } from '../../providers/smart-audio';
import { UserdataModel } from '../../providers/userdata-model';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  instext: string; 
  showntext: string;

  @ViewChild('homeslides') slides: Slides;

  constructor(public smartAudio: SmartAudio, public rubedoSideMenu: MenuController, public userdataModel:UserdataModel, public functions: Functions, public translate: TranslateService, public navCtrl: NavController, private storage: Storage) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  /* --------- LIFECYCLE --------- */
  ngOnInit(){ // at the init of the page moment
    //this.slides.centeredSlides=true;
    this.slides.initialSlide=0;
    this.slides.pager=true;
    this.slides.slidesPerView=2;
    this.slides.paginationType='bullets';
    this.slides.loop=true;
  }

  ionViewWillLeave(){
    //before the page leaves the viewport
    this.functions.setDifficulty();
    this.functions.setLanguage();
  }

  ionViewWillEnter(){    
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);
    this.functions.getDifficulty();
    this.functions.getLanguage();

    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  /* --------- END LIFECYCLE --------- */
  
  /* --------- FUNCTIONS --------- */
  goToPlay(chosenBook){
    if(!this.userdataModel.isBookComplete(chosenBook)){
      this.functions.idCurrentBook=chosenBook;
      //let currentIndex = this.slides.getActiveIndex();    
      this.navCtrl.push(PlayPage, {});
    }
  }

  goToReadStory(chosenBook){
    this.functions.idCurrentBook=chosenBook;
    this.navCtrl.push(ReadstoryPage, {});
  }
  
  addInstext(){
    this.showntext=this.showntext+' '+this.instext;
    this.instext='';
  }
  /* --------- END FUNCTIONs --------- */
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts